const utils = require('frontend-controller/lib/utils')

module.exports = {
    config: {
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_prices': true,
        },
    },

    model: {
        entities: {},

        parentEntity: false,
        jobID: 0,
    },

    events: {
        showEdit: {
            type: 'click',
            action(event){
                const self = event.data.component || {}

                const $li = $(event.target).closest('li')
                const entityID = $li.data('entityId')

                if(!entityID) {
                    self.performMessage({
                        messageDisplay: {
                            message: 'error:prices.priceTiles.cannotEditPriceWithoutID.message'
                        }
                    })
                    return
                }

                const entity = self.getEntityByKey(`entity_${entityID}`)
                if(!entity) {
                    self.performMessage({
                        messageDisplay: {
                            message: 'error:prices.priceTiles.cannotEditPriceWithoutData.message'
                        }
                    })
                    return
                }

                self.showEdit(
                    entityID,
                    entity
                )
            }
        }
    },

    methods: {
        init(storage, isServer){
            if(!this.model.parentEntity){
                this.model.parentEntity = this.getResourceRegisterContent('parentEntity') || false
            }
            if(this.model.parentEntity && !this.model.jobID){
                if(this.model.parentEntity.entityID && this.model.parentEntity.primaryKey === 'jobID'){
                    this.model.jobID = this.model.parentEntity.entityID
                    this.model.defaultPriceType = ((this.model.parentEntity.entityData || {}).attributes || {}).defaultPriceType || undefined
                }
            }
        },

        getResourceFilters: function(storage, resourceFilters, actionKey, fieldCode){
            resourceFilters = resourceFilters || {}

            if(actionKey === 'refreshResources') {

                this.init() // init via parentEntity if necessary

                resourceFilters.baseFilters = resourceFilters.baseFilters || {}
                resourceFilters.baseFilters.jobID = this.model.jobID
            }

            return resourceFilters
        },

        sanitizeResources(){
            const entities = this.model.entities = {}

            for(const entity of Object.values(this.resourceData.data || [])){
                const entityAttributes = entity.attributes || {}
                const entityID = entityAttributes[entity.primaryKey || 'id']
                const entityKey = `entity_${entityID}`
                delete entities[entityKey]
                entities[entityKey] = entity
            }
        },


        getEntityByKey(entityKey){
            return (this.model.entities || {})[entityKey || 'MISSING_KEY'] || null
        },


        async showEdit(entityID, entity){
            if(!this.model.jobID){
                return this.performMessage({
                    messageDisplay: {
                        message: 'error:prices.priceTiles.cannotEditPriceWithoutJob.message'
                    }
                })
            }

            const {
                priceID,
                priceConfig,
            } = ((entity || {}).attributes || {})

            const {
                code,
                title,
            } = (((this.model.parentEntity || {}).entityData || {}).attributes || {})

            const {
                validCode,
                validFrom,
                validTo,
            } = (priceConfig || {})

            if(!validFrom || !validTo){
                return this.performMessage({
                    messageDisplay: {
                        message: 'error:prices.priceTiles.cannotEditPriceWithoutValidPeriod.message'
                    }
                })
            }

            const modalSubTitle = `[${code}] ${title}`

            if(priceID) {
                return this.performAndStoreAction(
                    'showEdit_jobPrices_asCrew_inEffect',
                    this.prepareAction('showEdit_jobPrices_asCrew', priceID, {
                        priceConfigs: {
                            data: [{
                                attributes: priceConfig,
                                primaryKey: 'priceConfigID',
                            }]
                        },
                    }, {
                        source: {
                            load: {
                                componentData: {
                                    model: {
                                        subTitle: modalSubTitle,
                                    },
                                }
                            }
                        }
                    }),
                    true
                )
            }

            const updateGranted = utils.moment(validFrom).diff(utils.moment(), 's') > 0
            if(!updateGranted){
                const onDecisionPromise = utils.promise.newCustom(this)
                await this.performMessage({
                    onDecisionPromise,
                    messageDisplay: {
                        message: 'hint.addPricesAfterPriceConfigValidStarted.message'
                    }
                })
                const {
                    decisionComponent,
                } = await onDecisionPromise
                if(decisionComponent){
                    await decisionComponent.hide()
                }
            }

            await this.performAndStoreAction(
                'showInsert_prices_asCrew_inEffect',
                this.prepareAction('showInsert_prices_asCrew', undefined, {
                    priceConfigs: {
                        data: [{
                            attributes: priceConfig,
                            primaryKey: 'priceConfigID',
                        }]
                    },
                }, {
                    source: {
                        load: {
                            componentData: {
                                model: {
                                    subTitle: modalSubTitle,
                                },
                                actions: {
                                    loadContent: {
                                        source: {
                                            load: {
                                                componentData: {
                                                    model: {
                                                        dirtyFields: {
                                                            data: {
                                                                attributes: {
                                                                    jobID: this.model.jobID,
                                                                    type: this.model.defaultPriceType,
                                                                    valid: {
                                                                        code:   validCode,
                                                                        from:   validFrom,
                                                                        to:     validTo,
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                })
            )
        },

        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const refreshers    = this.config.heartbeatRefreshOn || {}
            const key           = message.heartbeatKey
            const employeeID = this.model.employeeID

            if(refreshers[key]) {
                // behave responsive according to marks if necessary.
                if(key === 'resourceChanged.bo_prices' && employeeID && (message.data.employeeIDs || {})[employeeID]){
                    this.refreshPricesSetByJobIDs()
                }
                // full refresh
                else {
                    this.refresh(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes })
                }
            }
        },
    },

    hooks: {
        async onDecision($element, options){
            switch(options.decisionComponent.componentClass) {
                case 'base_modal_modal':
                case 'templates_core_modal_modal':
                    switch(options.decisionType){
                        case 'submit':
                            const modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component;
                            if(modalContentComponent && modalContentComponent.hasClass('base_form_form')){
                                await modalContentComponent.submit()
                                await options.decisionComponent.hide()
                                return
                            }
                            break
                    }
                    await options.decisionComponent.hide()
                    break
            }
        },
    },

    handlers: [
        {
            name: 'heartbeat.resourceChanged',
            handle: function(callerComponent, message, heartbeatPrewarmedResourceHashes){
                this.onHeartbeat(message, heartbeatPrewarmedResourceHashes)
            }
        },
        {
            name: 'heartbeat.reconnect',
            handle: function(callerComponent, message, heartbeatPrewarmedResourceHashes){
                this.onHeartbeat(message, heartbeatPrewarmedResourceHashes)
            }
        },
    ],
}